import httpClient from '../../services/http-client';
import { API_SUB_URL_PATIENT_RESULT } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_PATIENT_RESULT, LOAD_LIST_PATIENT_RESULT, LOAD_A_PATIENT_RESULT, UPDATE_A_PATIENT_RESULT, DELETE_A_PATIENT_RESULT, 
    EXPORT_MEDICINE_TO_PDF,
} from '../actionTypes';

export const apiLoadListPatientResult = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_PATIENT_RESULT}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_PATIENT_RESULT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAPatientResult = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_PATIENT_RESULT}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_PATIENT_RESULT, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewPatientResult = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_PATIENT_RESULT, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_PATIENT_RESULT, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateAPatientResult = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_PATIENT_RESULT}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_PATIENT_RESULT, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteAPatientResult = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_PATIENT_RESULT}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_PATIENT_RESULT, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiExportMedicineToPDF = ({ payload }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(`${API_SUB_URL_PATIENT_RESULT}/pdf`, payload, {responseType: "blob"})
            .then(response => {
                dispatch(fetchDataSuccess(EXPORT_MEDICINE_TO_PDF, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};
